module.exports = __webpack_public_path__ + "06ff0400915271fac80bc897daf57ba5.png";